define("calendar/controllers/notes/edit", ["exports", "@ember/controller", "@ember/service", "@glimmer/tracking", "ember-concurrency", "ember-concurrency-ts"], function (_exports, _controller, _service, _tracking, _emberConcurrency, _emberConcurrencyTs) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;

  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency",0,"ember-concurrency-ts"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let EditController = (_dec = (0, _service.inject)('note'), (_class = class EditController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);

      _initializerDefineProperty(this, "errors", _descriptor3, this);

      _initializerDefineProperty(this, "intl", _descriptor4, this);

      _initializerDefineProperty(this, "noteService", _descriptor5, this);

      _initializerDefineProperty(this, "router", _descriptor6, this);

      _initializerDefineProperty(this, "note", _descriptor7, this);

      _initializerDefineProperty(this, "noteContent", _descriptor8, this);
    }

    get allowSave() {
      return this.noteService.shouldAllowSave(this.noteContent);
    }

    get charactersRemaining() {
      return this.noteService.getCharactersRemaining(this.noteContent);
    }

    get hasChanges() {
      return this.note.noteContent !== this.noteContent;
    }

    get showCharacterLimit() {
      return this.noteService.shouldShowCharacterLimit(this.noteContent);
    }

    *cancelUpdate() {
      yield (0, _emberConcurrencyTs.taskFor)(this.noteService.confirmClose).perform(this.hasChanges);
    }

    *copyToClipboard() {
      yield (0, _emberConcurrencyTs.taskFor)(this.noteService.copyToClipboard).perform(this.noteContent);
    }

    *deleteCalendarNote() {
      const didConfirm = yield this.dialogManager.confirmation(this.intl.t('calendar_notes.confirm_discard'), {
        confirmButton: this.intl.t('shared_words.discard')
      });

      if (!didConfirm) {
        return;
      }

      try {
        yield this.note.destroyRecord();
      } catch (error) {
        this.errors.handleAdapter(error, this.note);
      }

      this.noteService.transitionToCalendar();
    }

    *updateCalendarNote() {
      this.note.set('noteContent', this.noteContent);

      try {
        yield this.note.save();
      } catch (error) {
        this.errors.handleAdapter(error, this.note);
      }

      this.noteService.transitionToCalendar();
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "noteService", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "note", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "noteContent", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "cancelUpdate", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "cancelUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "copyToClipboard", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "copyToClipboard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteCalendarNote", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "deleteCalendarNote"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateCalendarNote", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "updateCalendarNote"), _class.prototype)), _class));
  _exports.default = EditController;
});